<template>
    <div class="card p-3 bg-white mb-1">
        <div class="card-header">
            <h3>{{ index+1 }}. témavezető</h3>
            <button class="x-icon-delete" @click.prevent="deleteTemavezeto" title="Témavezető törlése"></button>
            <button class="x-icon-up" :disabled="index == 0" @click.prevent="upTemavezeto" title="Témavezető feljebb csúsztatása"></button>
            <button class="x-icon-down" :disabled="index == palyamunka.temavezetok.length-1" @click.prevent="downTemavezeto" title="Témavezető lejjebb csúsztatása"></button>
        </div>
        <div class="card-body">
            <form>
                <div class="form-group">
                </div>
                <div class="form-group mb-1">
                    <label for="nev">Titulus</label>
                    <input type="text" id='titulus' v-model="temavezeto.titulus" class="form-control" title="Témavezető titulusa(i) (pl. 'Prof. Dr.')">
                </div>
                <div class="form-group mb-1">
                    <label for="nev">Vezetékneve</label>
                    <input type="text" id='nev' v-model="temavezeto.vezetekNev" class="form-control" title="Témavezető vezetékneve" required>
                </div>
                <div class="form-group mb-1">
                    <label for="nev">Keresztneve</label>
                    <input type="text" id='nev' v-model="temavezeto.keresztNev" class="form-control" title="Témavezető keresztneve" required>
                </div>
                <div class="form-group mb-1">
                    <label for="omAzon">Oktatási azonosító szám (amennyiben magyarországi felsőoktatási intézmény oktatója)</label>
                    <input type="text" id='omAzon' v-model="temavezeto.omAzon" class="form-control" title="Témavezető oktatási azonosító száma">
                </div>
                <div class="form-group mb-1">
                    <label for="email">E-mail címe</label>
                    <input type="text" id='email' v-model="temavezeto.email" class="form-control" required>
                </div>
                <div>
                    <label>Munkahelyek</label>
                    <munkahely v-for="(munkahely, index) in temavezeto.munkahelyek" :index="index" :munkahely="munkahely" :szemely="temavezeto" />
                    <div class="text-center">
                        <button class="btn btn-secondary btn-sm float-sm-left" @click.prevent="addFelsooktatasiMunkahely">Felsőoktatási munkahely felvétele</button>
                        &nbsp;
                        <button class="btn btn-secondary btn-sm float-sm-right" @click.prevent="addEgyebMunkahely">Egyéb munkahely felvétele</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Munkahely from './Munkahely.vue'

export default {
    components: {
        Munkahely
    },
    props: ['temavezeto', 'palyamunka', 'index'],
    methods: {
        deleteTemavezeto() {
            const index = this.palyamunka.temavezetok.indexOf(this.temavezeto);
            if (index > -1)
                this.palyamunka.temavezetok.splice(index, 1);
        },
        upTemavezeto() {
            const index = this.palyamunka.temavezetok.indexOf(this.temavezeto);
            if (index > 0) {
                let tmp = this.palyamunka.temavezetok[index-1];
                this.palyamunka.temavezetok[index - 1] = this.palyamunka.temavezetok[index];
                this.palyamunka.temavezetok[index] = tmp;
            }
        },
        downTemavezeto() {
            const index = this.palyamunka.temavezetok.indexOf(this.temavezeto);
            if (index < this.palyamunka.temavezetok.length) {
                let tmp = this.palyamunka.temavezetok[index+1];
                this.palyamunka.temavezetok[index + 1] = this.palyamunka.temavezetok[index];
                this.palyamunka.temavezetok[index] = tmp;
            }
        },
        availableKar() {
            var intezmenyKod = this.temavezeto.intezmenyKod;
            var intezmenyObj = this.intezmenyek.find((x) => x.kod == intezmenyKod);
            if (intezmenyObj)
                return intezmenyObj.karok;
            else
                return this.intezmenyek;
        },
        addFelsooktatasiMunkahely() {
            this.$storage.createFelsooktatasiMunkahely(this.temavezeto);
        },
        addEgyebMunkahely() {
            this.$storage.createEgyebMunkahely(this.temavezeto);
        }
    }
}
</script>
